import type { ConditionRuleProblem } from "@repo/shared";

/**
 * Messages for `findConditionRuleProblem` codes — one table for every flow
 * and PDF condition dialog instead of a copy in each.
 */

export const T = {
  en_GB: {
    missing_source: "Please select a source field for conditional display",
    missing_quiz: "The quiz this rule points at no longer exists. Pick another source field.",
    missing_assessment:
      "The product type or assessment mode this rule points at is no longer available. Pick another source field.",
    empty_goal_type_selection: "Please select at least one goal type",
    value_required: "Please enter a value to compare",
  },
  nb_NO: {
    missing_source: "Vennligst velg et kildefelt for betinget visning",
    missing_quiz: "Quizen denne regelen peker på finnes ikke lenger. Velg et annet kildefelt.",
    missing_assessment:
      "Produkttypen eller vurderingsmodusen denne regelen peker på er ikke lenger tilgjengelig. Velg et annet kildefelt.",
    empty_goal_type_selection: "Vennligst velg minst én måltype",
    value_required: "Vennligst skriv inn en verdi å sammenligne",
  },
} as const satisfies Record<string, Record<ConditionRuleProblem, string>>;
